import React from 'react'

import NotFoundMessage from '../../components/UI/NotFoundMessage/NotFoundMessage';

const NotFound = () => {
   return (
      <NotFoundMessage message="404 Not Found Page" />
   );
}

export default NotFound;